import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import JoinOfficeReq from './JoinOfficeReq';
import RelieveOfficeReq from './RelieveOfficeReq';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';


const ButtonContainer = styled.div`
  display: flex;
  justify-content:center;
`
const ChoiceButtons = styled.button`
    display: inline-flex;
    -webkit-box-align: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.75;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    min-width: 164px;
    padding: 6px 16px;
    border-radius: 4px;
    border-width: 0;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: #fff;
    background-color: #5C5891;
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
    margin: 40px;
`



const ChangeOfficeReq = () => {
    const [compToggle, setCompToggle] = useState({
        home:true,
        joinOff:false,
        relieveOff:false
    })
    const [userData, setUserData] = useState([]);


    const {userdata} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
        userdata: data?.entities
    }),
    })
    const handleButtonClick = (e) => {
    let tempToggle = structuredClone(compToggle);
        if(e.target.name === 'joinoffice'){
        tempToggle.home = false;
        tempToggle.joinOff = true;
        setCompToggle(tempToggle);
        }
        if(e.target.name === 'relieveoffice'){
        tempToggle.home = false;
        tempToggle.relieveOff = true;
        setCompToggle(tempToggle);

        }
    }
    useEffect(()=>{
        if(userdata){
        setUserData(userdata)
        }
    },[userdata])

  return (
    <>
        {compToggle?.home && <ButtonContainer>
            <ChoiceButtons name='joinoffice' onClick={handleButtonClick}>Join Office</ChoiceButtons>
            <ChoiceButtons name='relieveoffice' onClick={handleButtonClick}>Relieve Office</ChoiceButtons>
        </ButtonContainer>}
        {compToggle.joinOff && <JoinOfficeReq userData={userData} compToggle={compToggle} setCompToggle={setCompToggle} />}
        {compToggle.relieveOff && <RelieveOfficeReq userData={userData} compToggle={compToggle} setCompToggle={setCompToggle} />}
    </>
  )
}

export default ChangeOfficeReq